import { useContext } from "react";
import HolidayContext from "../contexts/holidaysContext";

const useHolidays = () => useContext(HolidayContext);

export default useHolidays;
